// reCAPTCHA site keys are public — they ship in the rendered HTML for
// users to inspect either way — so it's fine to commit them. Switch on
// the runtime hostname so prod gets the real key and everything else
// (dev, local) falls back to Google's universal test key (always passes
// server-side verification, shows the "for testing purposes only" badge).
const PROD_KEY = "6LfPm_cqAAAAAEUGYnjNGjSVFmVbt8FpAljNbVMX";
const TEST_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

const isProdHost =
  typeof window !== "undefined" &&
  window.location.hostname === "public-tools.prod.aws.cinch.io";

export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY || (isProdHost ? PROD_KEY : TEST_KEY);
